import jQuery from 'jquery';
import 'slick-carousel';

jQuery(function ($) {
    'use strict';

    const $galleryCarousel = $('.gallery--carousel .gallery__slides');
    const closeModalSVG =
        '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M20 0C8.94 0 0 8.94 0 20C0 31.06 8.94 40 20 40C31.06 40 40 31.06 40 20C40 8.94 31.06 0 20 0ZM25.18 12L20 17.18L14.82 12L12 14.82L17.18 20L12 25.18L14.82 28L20 22.82L25.18 28L28 25.18L22.82 20L28 14.82L25.18 12ZM4 20C4 28.82 11.18 36 20 36C28.82 36 36 28.82 36 20C36 11.18 28.82 4 20 4C11.18 4 4 11.18 4 20Z" fill="black"/></svg>';

    $galleryCarousel.each(function () {
        let $this = $(this);

        $this.find('.gallery__slides__items').slick({
            arrows: true,
            autoplay: false,
            autoplaySpeed: 8000,
            infinite: true,
            prevArrow: $this.find('.gallery__slides__prev'),
            nextArrow: $this.find('.gallery__slides__next'),
            slidesToShow: 1,
            adaptiveHeight: true,
        });

        $this.find('.gallery__slides__items').on('afterChange', function (event, slick, index) {
            $this.find('.gallery__slides__num__counter').text(index + 1);
        });

        if ($this.find('.slick-slide:not(.slick-cloned) a').length > 0) {
            $this.find('.slick-slide:not(.slick-cloned) a').magnificPopup({
                type: 'image',
                gallery: {
                    enabled: true,
                    tCounter: 'Image %curr% of %total%',
                    tPrev: 'Previous image',
                    tNext: 'Next image',
                },
                closeMarkup:
                    '<button title="%title%" aria-label="Close (Esc)" type="button" class="mfp-close">' +
                    closeModalSVG +
                    '</button>',
                callbacks: {
                    open: function () {
                        $this.on('keydown', function (e) {
                            // Left Arrow (37) - Previous image
                            if (e.keyCode === 37) {
                                $.magnificPopup.instance.prev();
                            }
                            // Right Arrow (39) - Next image
                            else if (e.keyCode === 39) {
                                $.magnificPopup.instance.next();
                            }
                            // Escape (27) - Close popup
                            else if (e.keyCode === 27) {
                                $.magnificPopup.close();
                            }
                        });
                    },
                    close: function () {
                        // Remove the keydown event listener when popup is closed
                        $this.off('keydown');
                    },
                },
            });
        }

        // Ensure keyboard navigation trap is forced to stay within popup
        $('body').on('focus', '.mfp-wrap', function (e) {
            let $this = $(this);

            if ($(e.target).is($this)) {
                $('.mfp-close').focus();
                $this.attr('aria-hidden', 'true');
                $('.mfp-close').attr('aria-hidden', 'false');
                $('.mfp-arrow').attr('aria-hidden', 'false');
            }
        });

        $this.find('.gallery__slides__open').click(function (e) {
            e.preventDefault();
            $galleryCarousel.find('.slick-active a').click();
        });
    });

    $('.gallery:not(.gallery--carousel)').each(function () {
        let $this = $(this);

        $(this)
            .find('.image')
            .magnificPopup({
                type: 'image',
                gallery: {
                    enabled: true,
                    tCounter: 'Image %curr% of %total%',
                    tPrev: 'Previous image',
                    tNext: 'Next image',
                },
                closeMarkup:
                    '<button title="%title%" aria-label="Close (Esc)" type="button" class="mfp-close">' +
                    closeModalSVG +
                    '</button>',
                callbacks: {
                    open: function () {
                        $this.on('keydown', function (e) {
                            // Left Arrow (37) - Previous image
                            if (e.keyCode === 37) {
                                $.magnificPopup.instance.prev();
                            }
                            // Right Arrow (39) - Next image
                            else if (e.keyCode === 39) {
                                $.magnificPopup.instance.next();
                            }
                            // Escape (27) - Close popup
                            else if (e.keyCode === 27) {
                                $.magnificPopup.close();
                            }
                        });
                    },
                    close: function () {
                        // Remove the keydown event listener when popup is closed
                        $this.off('keydown');
                    },
                },
            });
    });
});
